import { createBrowserOrpc } from '@harmoni/rpc/browser'
import { env } from './env'

export const { link, client, orpc } = createBrowserOrpc(env.apiUrl)
